import Vue from 'vue'
import Vuex from 'vuex'

import usuario from './modules/usuario'
import loginModule from "./modules/login";
import staticModule from "./modules/static";
import processamentos from "./modules/processamentos";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        usuarioModule: usuario,
        login: loginModule,
        static: staticModule,
        processamentos,
    },
    state: {
        drawer: localStorage.getItem('drawer') !== null ? JSON.parse(localStorage.getItem('drawer')) : true,
        loader: false
    },
    mutations:{
        Loader(state, payload){
            state.loader = payload;
        }
    },
    getters:{
        getLoader: (state) => {
          return state.loader;
      },
      },
      actions: {}    
})